module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/landing-desktop-cucarda-fuego.70152465.png";